export default __webpack_public_path__ + "static/media/three.4df6496d.svg";